import breakpoints from "../../breakpoints";
import { ComponentsOverrides, Theme } from "@mui/material";

const dialogActions = (): ComponentsOverrides<Theme>["MuiDialogActions"] => ({
	root: {
		paddingTop: "1.6rem",
		paddingLeft: "var(--panelOutSpacingHor)",
		paddingRight: "var(--panelOutSpacingHor)",
		paddingBottom: "var(--panelOutSpacingVer)",
		flexDirection: "row-reverse",
		alignItems: "stretch",
		justifyContent: "center",

		"&& > *": {
			flexGrow: 1,
			flexBasis: 0,
			marginLeft: "0.8rem",
			maxWidth: "360px",

			"&:last-child": {
				marginLeft: "0",
			},
		},

		[`@media (max-width:${breakpoints.values.md - 0.05}px)`]: {
			paddingLeft: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
			paddingRight: "calc(var(--panelOutSpacingHor) + var(--panelInSpacing))",
			flexDirection: "column",
			alignItems: "stretch",
			paddingBottom: "1.6rem",
			"&& .MuiButton-root": {
				flexGrow: 1,
				marginLeft: 0,
				maxWidth: "100%",
				marginBottom: "0.8rem",
			},

			"&& > *:last-child": {
				marginBottom: "0",
			},
		},
	},
});

export default dialogActions;
